import { jsx as a, jsxs as m } from "react/jsx-runtime";
import { Fragment as n } from "react";
import r from "./roche-pharma-card-content.module.scss.js";
const l = ({ fields: t }) => /* @__PURE__ */ a("dl", { className: r["pharma-card-content"], children: t.map(({ label: e, value: c }) => /* @__PURE__ */ m(n, { children: [
  /* @__PURE__ */ a("dt", { className: r["pharma-card-content__label"], children: e }),
  /* @__PURE__ */ a("dd", { className: r["pharma-card-content__value"], children: c })
] }, e)) });
export {
  l as RocheUIPharmaCardContent
};
